import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import Input from "@/components/Usados/InputField";
import Label from "@/components/Usados/Label";
import Button from "@/components/ui/button/Button";
import Switch from "@/components/form/switch/Switch";
import Alert from "@/components/ui/alert/Alert";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { ChevronLeft } from "lucide-react";
import { apiFetch } from "@/service/api";

export default function UpdateSucursal() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({
    nombre: "",
    direccion: "",
    ciudad: "",
    pais: "",
    telefono: "",
    estado: true,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiFetch(`sucursales/find-one/${id}`);
        if (res.ok) {
          const data = await res.json();
          setForm(data);
        } else {
          setError("No se pudo cargar la informacion de la sucursal.");
        }
      } catch (err) {
        setError("Error de conexion al cargar los datos.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  function handleChange(e: any) {
    const { name, value } = e.target;
    setForm((prev: any) => ({ ...prev, [name]: value }));
  }

  const handleSwitchChange = (checked: boolean) => {
    setForm((prev: any) => ({ ...prev, estado: checked }));
  };

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      const { id: _, empresa, ...updateData } = form;
      const response = await apiFetch(`sucursales/update/${id}`, {
        method: "PATCH",
        body: JSON.stringify(updateData),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al actualizar la sucursal");
      }
      setSuccess(true);
      setTimeout(() => navigate("/multiempresa/sucursales"), 1000);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  if (loading)
    return (
      <div className="flex justify-center items-center min-h-">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
      </div>
    );

  return (
    <div>
      <PageBreadcrumb pageTitle="Actualizar Sucursal" />
      <div className="mb-6">
        <button
          onClick={() => navigate("/multiempresa/sucursales")}
          className="inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          <ChevronLeft className="size-5" />
          Volver al listado
        </button>
      </div>
      <div className="min-h-screen rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <h3 className="mb-8 font-semibold text-gray-800 text-center text-theme-xl dark:text-white/90 sm:text-2xl">
          Actualizar Informacion de Sucursal
        </h3>
        {error && (
          <div className="mb-6">
            <Alert variant="error" title="Error" message={error} />
          </div>
        )}
        {success && (
          <div className="mb-6">
            <Alert
              variant="success"
              title="exito"
              message="Sucursal actualizada correctamente. Redirigiendo..."
            />
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-2">
            <div>
              <Label>Nombre de la Sucursal</Label>
              <Input
                name="nombre"
                type="text"
                value={form.nombre}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Direccion</Label>
              <Input
                name="direccion"
                type="text"
                value={form.direccion}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Ciudad</Label>
              <Input
                name="ciudad"
                type="text"
                value={form.ciudad}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Pais</Label>
              <Input
                name="pais"
                type="text"
                value={form.pais}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Telefono</Label>
              <Input
                name="telefono"
                type="text"
                value={form.telefono}
                onChange={handleChange}
                required
              />
            </div>
            <div className="flex items-center gap-3">
              <Label>Estado Activo</Label>
              <Switch
                label=""
                defaultChecked={form.estado}
                onChange={handleSwitchChange}
              />
            </div>
          </div>
          <div className="mt-10 flex justify-end gap-3">
            <Button
              variant="outline"
              size="md"
              type="button"
              onClick={() => navigate("/multiempresa/sucursales")}
              disabled={saving}
            >
              Cancelar
            </Button>
            <Button variant="primary" size="md" type="submit" disabled={saving}>
              {saving ? "Guardando..." : "Actualizar Sucursal"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
